module.exports = __webpack_public_path__ + "img/advan-one.800c77b2.png";